var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMedal(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 32,
    fill: "none",
    viewBox: "0 0 24 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Medal") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#7491D2",
    d: "M6.435 20.87H8.522V30.609H6.435z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#7491D2",
    d: "M7.594 20.869H9.913V29.217H7.594z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#7491D2",
    d: "M9.449 22.26H11.304V27.825000000000003H9.449z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#7491D2",
    d: "M11.072 22.26H12.927V26.434H11.072z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#7491D2",
    d: "M12.696 22.26H14.551V27.825000000000003H12.696z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#7491D2",
    d: "M14.087 22.26H15.942V29.217000000000002H14.087z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#7491D2",
    d: "M14.783 20.869H16.406V30.608H14.783z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#7491D2",
    d: "M16.174 20.869H17.564999999999998V30.608H16.174z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#FBDE4B",
    d: "M9.218 1.392H14.783000000000001V20.87H9.218z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#FBDE4B",
    d: "M6.435 2.783H10.145V19.479000000000003H6.435z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#FBDE4B",
    d: "M13.855 2.783H17.565V19.479000000000003H13.855z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#FBDE4B",
    d: "M16.87 4.174H18.957V18.087H16.87z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#FBDE4B",
    d: "M5.044 4.174H7.3629999999999995V18.087H5.044z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#FBDE4B",
    d: "M3.652 5.565H5.739000000000001V16.695H3.652z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "#FBDE4B",
    d: "M18.029 5.565H20.348V16.695H18.029z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "#FBDE4B",
    d: "M19.652 8.348H21.739V13.913H19.652z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "#FBDE4B",
    d: "M2.261 8.348H5.275V13.913H2.261z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "#FEFDBE",
    d: "M6.435 2.783H7.826V4.1739999999999995H6.435z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "#FEFDBE",
    d: "M5.043 4.174H6.434V5.565H5.043z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "#FEFDBE",
    d: "M3.652 5.565H5.043V8.348H3.652z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "#FEFDBE",
    d: "M9.217 1.392H10.608V2.783H9.217z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fill: "#F7BF4A",
    d: "M10.609 6.957H13.392V15.305H10.609z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fill: "#F7BF4A",
    d: "M16.174 9.739H18.957V18.087000000000003H16.174z",
    transform: "rotate(90 16.174 9.74)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fill: "#F7BF4A",
    d: "M15.559 8.534H16.79V15.715H15.559z",
    transform: "rotate(90 15.559 8.534)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fill: "#F7BF4A",
    d: "M8.378 13.663H9.609V20.844H8.378z",
    transform: "rotate(-90 8.378 13.663)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fill: "#F7BF4A",
    d: "M15.148 7.918H15.764V14.278H15.148z",
    transform: "rotate(90 15.148 7.918)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fill: "#F7BF4A",
    d: "M8.788 14.278H9.404V20.638H8.788z",
    transform: "rotate(-90 8.788 14.278)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fill: "#F7BF4A",
    d: "M14.533 7.302H15.149V12.431H14.533z",
    transform: "rotate(90 14.533 7.302)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fill: "#F7BF4A",
    d: "M9.404 14.894H10.02V20.023H9.404z",
    transform: "rotate(-90 9.404 14.894)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fill: "#F6B52D",
    d: "M10.435 4.87H13.565000000000001V5.6530000000000005H10.435z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fill: "#F6B52D",
    d: "M10.435 16.609H13.565000000000001V17.392000000000003H10.435z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fill: "#F6B52D",
    d: "M10.435 6.435H12V7.218H10.435z",
    transform: "rotate(-180 10.435 6.435)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fill: "#F6B52D",
    d: "M13.565 15.826H15.129999999999999V16.609H13.565z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fill: "#F6B52D",
    d: "M10.435 16.609H12V17.392000000000003H10.435z",
    transform: "rotate(-180 10.435 16.609)"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fill: "#F6B52D",
    d: "M13.565 5.652H15.129999999999999V6.4350000000000005H13.565z"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fill: "#F6B52D",
    d: "M6.522 9.565H8.087V10.347999999999999H6.522z",
    transform: "rotate(-90 6.522 9.565)"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    fill: "#F6B52D",
    d: "M17.479 12.696H19.044V13.479H17.479z",
    transform: "rotate(90 17.479 12.696)"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    fill: "#F6B52D",
    d: "M6.522 14.261H8.087V15.043999999999999H6.522z",
    transform: "rotate(-90 6.522 14.26)"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    fill: "#F6B52D",
    d: "M17.479 8H19.044V8.783H17.479z",
    transform: "rotate(90 17.479 8)"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    fill: "#F6B52D",
    d: "M7.305 8H8.088V8.783H7.305z",
    transform: "rotate(-90 7.305 8)"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    fill: "#F6B52D",
    d: "M16.696 14.261H17.479000000000003V15.043999999999999H16.696z",
    transform: "rotate(90 16.696 14.26)"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    fill: "#F6B52D",
    d: "M7.305 15.043H8.088V15.825999999999999H7.305z",
    transform: "rotate(-90 7.305 15.043)"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    fill: "#F6B52D",
    d: "M16.696 7.218H17.479000000000003V8.001H16.696z",
    transform: "rotate(90 16.696 7.218)"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    fill: "#F6B52D",
    d: "M8.087 15.826H8.87V16.609H8.087z",
    transform: "rotate(-90 8.087 15.826)"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    fill: "#F6B52D",
    d: "M15.913 6.435H16.696V7.218H15.913z",
    transform: "rotate(90 15.913 6.435)"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    fill: "#F6B52D",
    d: "M8.087 7.218H8.87V8.001H8.087z",
    transform: "rotate(-90 8.087 7.218)"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    fill: "#F6B52D",
    d: "M15.913 15.043H16.696V15.825999999999999H15.913z",
    transform: "rotate(90 15.913 15.043)"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    fill: "#F6B52D",
    d: "M6.522 9.565H9.652000000000001V10.347999999999999H6.522z",
    transform: "rotate(90 6.522 9.565)"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    fill: "#F6B52D",
    d: "M17.479 12.696H20.608999999999998V13.479H17.479z",
    transform: "rotate(-90 17.479 12.696)"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    fill: "#202225",
    d: "M5.044 32.001H17.74V33.391999999999996H5.044z",
    transform: "rotate(-90 5.044 32)"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    fill: "#202225",
    d: "M6.435 32.001H7.826V34.088H6.435z",
    transform: "rotate(-90 6.435 32)"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    fill: "#202225",
    d: "M8.522 30.609H9.913V32H8.522z",
    transform: "rotate(-90 8.522 30.609)"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    fill: "#202225",
    d: "M9.913 29.218H11.304V30.609H9.913z",
    transform: "rotate(-90 9.913 29.218)"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    fill: "#202225",
    d: "M11.305 27.827H12.696V29.218000000000004H11.305z",
    transform: "rotate(-90 11.305 27.827)"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    fill: "#202225",
    d: "M12.696 29.218H14.087V30.609H12.696z",
    transform: "rotate(-90 12.696 29.218)"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    fill: "#202225",
    d: "M14.087 30.609H15.478V32H14.087z",
    transform: "rotate(-90 14.087 30.609)"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    fill: "#202225",
    d: "M15.479 32.001H16.869999999999997V34.088H15.479z",
    transform: "rotate(-90 15.479 32)"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    fill: "#202225",
    d: "M17.565 32.001H30.261000000000003V33.391999999999996H17.565z",
    transform: "rotate(-90 17.565 32)"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    fill: "#202225",
    d: "M9.218 0H14.783000000000001V1.391H9.218z"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    fill: "#202225",
    d: "M9.218 20.87H14.783000000000001V22.261000000000003H9.218z"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    fill: "#202225",
    d: "M9.218 2.783H12.001V4.1739999999999995H9.218z",
    transform: "rotate(-180 9.218 2.783)"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    fill: "#202225",
    d: "M14.783 19.478H17.566V20.869H14.783z"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    fill: "#202225",
    d: "M9.218 20.87H12.001V22.261000000000003H9.218z",
    transform: "rotate(-180 9.218 20.87)"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    fill: "#202225",
    d: "M14.783 1.391H17.566V2.782H14.783z"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    fill: "#202225",
    d: "M2.261 8.348H5.0440000000000005V9.739H2.261z",
    transform: "rotate(-90 2.261 8.348)"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    fill: "#202225",
    d: "M21.739 13.913H24.522000000000002V15.304H21.739z",
    transform: "rotate(90 21.74 13.913)"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    fill: "#202225",
    d: "M2.261 16.696H5.0440000000000005V18.087000000000003H2.261z",
    transform: "rotate(-90 2.261 16.696)"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    fill: "#202225",
    d: "M21.739 5.565H24.522000000000002V6.956H21.739z",
    transform: "rotate(90 21.74 5.565)"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    fill: "#202225",
    d: "M3.653 5.565H5.0440000000000005V6.956H3.653z",
    transform: "rotate(-90 3.653 5.565)"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    fill: "#202225",
    d: "M20.348 16.696H21.738999999999997V18.087000000000003H20.348z",
    transform: "rotate(90 20.348 16.696)"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    fill: "#202225",
    d: "M3.653 18.087H5.0440000000000005V19.478H3.653z",
    transform: "rotate(-90 3.653 18.087)"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    fill: "#202225",
    d: "M20.348 4.174H21.738999999999997V5.565H20.348z",
    transform: "rotate(90 20.348 4.174)"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    fill: "#202225",
    d: "M5.044 19.478H6.435V20.869H5.044z",
    transform: "rotate(-90 5.044 19.478)"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    fill: "#202225",
    d: "M18.957 2.783H20.348V4.1739999999999995H18.957z",
    transform: "rotate(90 18.957 2.783)"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    fill: "#202225",
    d: "M5.044 4.174H6.435V5.565H5.044z",
    transform: "rotate(-90 5.044 4.174)"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    fill: "#202225",
    d: "M18.957 18.087H20.348V19.478H18.957z",
    transform: "rotate(90 18.957 18.087)"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    fill: "#202225",
    d: "M2.261 8.348H7.8260000000000005V9.739H2.261z",
    transform: "rotate(90 2.261 8.348)"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    fill: "#202225",
    d: "M21.739 13.913H27.304000000000002V15.304H21.739z",
    transform: "rotate(-90 21.74 13.913)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedal);
export default __webpack_public_path__ + "static/media/medal.655971c3f7ba5464e47f3eaf5b8e6be4.svg";
export { ForwardRef as ReactComponent };